const tr: any = {
  title: {
    fr: "Popcard Pro Standard",
    ar: "Popcard Pro Standard",
    en: "Popcard Pro Standard",
  },
  description: {
    fr: `Carte de visite digitale premium en noir mat avec NFC pour centraliser "votre univers digital sur une seule carte"`,
    ar: "بطاقة عمل رقمية مميزة باللون الأسود غير اللامع مع تقنية NFC لتوحيد عالمك الرقمي في لفتة واحدة.",
    en: "Premium digital business card in matte black with NFC to centralize your digital world on a single card",
  },
  partageIlimite: {
    fr: "Partage illimitée",
    ar: "مشاركة غير محدودة",
    en: "Unlimited sharing",
  },
  collectIllimite: {
    fr: "Collecte de contacts illimité",
    ar: "جمع جهات الاتصال بشكل غير محدود",
    en: "Unlimited contact collection",
  },
  modificationsVosInformation: {
    fr: "Modification de vos informations à tout moment",
    ar: "يمكنك تعديل معلوماتك في أي وقت.",
    en: "Edit your information at any time",
  },
  qrCodeImprime: {
    fr: "Qr code imprimé sur le dos de la carte pour les téléphones non compatibles avec NFC",
    ar: "رمز الاستجابة السريعة (QR code) مطبوع على الجزء الخلفي من البطاقة للهواتف غير المتوافقة مع تقنية NFC.",
    en: "QR code printed on the back of the card for phones not compatible with NFC",
  },
  NamePoste: {
    fr: "Nom, prénom et intitulé de poste imprimés sur la carte",
    ar: "الاسم الكامل واللقب والمسمى الوظيفي مطبوعة على البطاقة",
    en: "Full name and job title printed on the card",
  },
  PartielPersonalization: {
    fr: "Personnalisation Partielle",
    ar: "تخصيص الجزئي",
    en: "Partial personalization",
  },
  Pesonalization: {
    fr: "Personnalisation avec votre logo",
    ar: "تخصيص بطاقتك بشعارك الخاص",
    en: "Customization with your logo",
  },
  detailedStatictics: {
    fr: "Statistiques détaillées (Popcard Metrics)",
    ar: "إحصائيات مفصلة (مقاييس بوبكارد)",
    en: "Detailed statistics (Popcard Metrics)",
  },
  liensPdfs: {
    fr: "Liens réseaux sociaux, documents PDF, Images, Vidéos, Lien de prise de rendez-vous, informations de contact..",
    ar: "روابط الشبكات الاجتماعية، مستندات PDF، صور، فيديوهات، رابط لحجز المواعد، معلومات الاتصال",
    en: "Social media links, PDF documents, images, videos, appointment booking link, contact information..",
  },
  colors: {
    fr: "Couleur de l'impression :",
    ar: "لون الطباعة",
    en: "Print color:",
  },
  fullName: {
    fr: "Nom et Prénom*",
    ar: "الاسم الكامل *",
    en: "Full Name*",
  },
  enterprise: {
    fr: "Entreprise ou Métier*",
    ar: "الشركة أو الأعمال *",
    en: "Company or Profession*",
  },
  email: {
    fr: "Adresse Email*",
    ar: "البريد الإلكتروني *",
    en: "Email Address*",
  },
  phone: {
    fr: "Téléphone*",
    ar: "الهاتف",
    en: "Phone*",
  },
  address: {
    fr: "Adresse Exacte *",
    ar: "العنوان*",
    en: "Exact Address*",
  },
  city: {
    fr: "Ville *",
    ar: "المدينة *",
    en: "City*",
  },
  qty: {
    fr: "Quantité*",
    ar: "الكمية *",
    en: "Quantity*",
  },
  codePromo: {
    fr: "Code Promo",
    ar: "كوبون",
    en: "Promo Code",
  },
  livraison: {
    fr: "Livraison gratuite partout au maroc",
    ar: "توصيل مجاني في أي مكان في المغرب",
    en: "Free delivery anywhere in Morocco",
  },
  Confirmer: {
    fr: "Confirmer",
    ar: "تأكيد الطلب",
    en: "Confirm",
  },
  mad: {
    fr: "MAD",
    ar: "درهم",
    en: "MAD",
  },
};

export default tr;
